import React from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import closeIcon from "../../assets/cross.svg";

// Permanent removal of selected pending student invites (roster mistake
// cleanup). Deletes the invite rows and invalidates their links. Mirrors
// DeleteStudentModal's strong-red confirm styling.
const RemoveInvitesModal = ({ count = 0, onClose, onConfirm, isRemoving }) => {
  const { t } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center">
      <div className="w-[500px] bg-white rounded-[20px] overflow-hidden font-['Manrope']">
        {/* Header */}
        <div className="p-6 bg-gradient-to-br from-white to-red-50 border-b border-red-100 flex justify-between items-center">
          <h2 className="text-[18px] font-bold text-gray-900">
            {t("modals.removeInvites.title", { defaultValue: "Remove {{count}} invite(s)?", count })}
          </h2>
          <button onClick={onClose} className="p-1" disabled={isRemoving}>
            <img src={closeIcon} alt={t("modals.common.close", { defaultValue: "Close" })} className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 pb-6 pt-6 flex flex-col gap-8">
          <div className="text-[16px] leading-normal">
            <span className="text-gray-900 font-bold">
              {t("modals.removeInvites.warning", {
                defaultValue: "This permanently deletes the selected invite(s) and their invite links will stop working.",
              })}
            </span>
            <br />
            <br />
            <span className="text-gray-500 font-medium">
              {t("modals.removeInvites.hint", {
                defaultValue: "Students who have already accepted aren't affected — remove those from Active Students.",
              })}
            </span>
          </div>

          {/* Footer Buttons */}
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              disabled={isRemoving}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-gray-900 border border-gray-300 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {t("modals.removeInvites.cancel", { defaultValue: "Cancel" })}
            </button>
            <button
              onClick={onConfirm}
              disabled={isRemoving}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-white bg-red-600 rounded-lg hover:bg-red-700 transition-colors disabled:opacity-60 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {isRemoving && <Loader2 size={16} className="animate-spin" />}
              {isRemoving
                ? t("modals.removeInvites.removing", { defaultValue: "Removing…" })
                : t("modals.removeInvites.confirm", { defaultValue: "Remove permanently" })}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RemoveInvitesModal;
